import { baseApi } from './baseApi';

export const eventsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listEvents: builder.query({
      query: (queryString = '') => ({
        url: queryString ? `events/list?${queryString}` : 'events/list',
        method: 'GET',
      }),
      providesTags: ['Events'],
    }),

    getEvent: builder.query({
      query: (eventId) => ({
        url: `events/get/${eventId}`,
        method: 'GET',
      }),
      providesTags: (result, error, eventId) => [{ type: 'Event', id: eventId }],
    }),

    addEvent: builder.mutation({
      query: (body) => ({
        url: 'events/create',
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Events'],
    }),

    updateEvent: builder.mutation({
      query: (body) => ({
        url: 'events/update',
        method: 'PUT',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, body) => [
        { type: 'Event', id: body?.id },
        'Events',
      ],
    }),

    deleteEvent: builder.mutation({
      query: (eventId) => ({
        url: `events/delete/${eventId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Events'],
    }),
  }),
});

export const {
  useListEventsQuery,
  useGetEventQuery,
  useAddEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = eventsApi;

